export default "/build/images/forbidden.0fd2f0bd.gif";